import { useCallback, useMemo } from "react";

import { useBonusApiService } from "shared/services";

import { useBonusStore } from "../contexts";

import type { IgnoreStateUpdate } from "../types";
import type { BonusTypes } from "../types/BonusModel";

const useBonus = () => {
	const bonusService = useBonusApiService();

	const store = useBonusStore();
	const { setState, setInitial } = useBonusStore();

	const methods = useMemo(() => {
		return {
			async listBonuses(
				params: { type?: BonusTypes; dateFrom?: string; dateTo?: string; event?: string },
				stateParam?: IgnoreStateUpdate
			) {
				try {
					if (!stateParam?.ignoreLoading) {
						setState({ loading: true });
					}
					const res = await bonusService.list(params);

					if (!stateParam?.ignoreStateUpdate) {
						setState({ bonuses: res.data || [] });
					}

					return res?.data || [];
				} catch (error) {
					console.log(error);
					return [];
				} finally {
					if (!stateParam?.ignoreLoading) {
						setState({ loading: false });
					}
				}
			},
			resetStore() {
				setInitial();
			}
		};
	}, [bonusService, setState, setInitial]);

	const getData = useCallback(() => {
		return store;
	}, [store]);

	return { ...methods, getData };
};

export default useBonus;
